var r = function r(_r) {
    return "object" == typeof _r && null !== _r && "message" in _r && "string" == typeof _r.message;
  },
  e = function e(_e) {
    if (r(_e)) return _e;
    try {
      return new Error(JSON.stringify(_e));
    } catch (r) {
      return new Error(String(_e));
    }
  },
  t = function t(r) {
    return e(r).message;
  },
  n = function n(r) {
    var e = new FormData(r.target);
    return Object.fromEntries(e);
  };
export { t as getErrorMessage, n as getFormDataFromEvent, r as isErrorWithMessage, e as toErrorWithMessage };